import { mergeClassNames } from "../../utils/classes";

import type { ReactNode } from "react";

import * as styles from "./modal.scss";

interface ModalFooterProps {
	centered?: boolean;
	children?: ReactNode;
	className?: string;
}

export const ModalFooter = (props: ModalFooterProps) => {
	const modalClassName = mergeClassNames(props.centered ? styles.footerCentered : styles.footer, props.className);
	return <div className={modalClassName}>{props.children}</div>;
};
